import { render, staticRenderFns } from "./SDStatusEdit.vue?vue&type=template&id=54608464&scoped=true"
import script from "./SDStatusEdit.vue?vue&type=script&lang=js"
export * from "./SDStatusEdit.vue?vue&type=script&lang=js"
import style0 from "./SDStatusEdit.vue?vue&type=style&index=0&id=54608464&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54608464",
  null
  
)

export default component.exports